import { render, staticRenderFns } from "./BookingSlots.vue?vue&type=template&id=25701f90&"
import script from "./BookingSlots.vue?vue&type=script&lang=js&"
export * from "./BookingSlots.vue?vue&type=script&lang=js&"
import style0 from "./BookingSlots.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports